import { render, staticRenderFns } from "./RelocateSubSampleModal.vue?vue&type=template&id=640a3f94&scoped=true&"
import script from "./RelocateSubSampleModal.vue?vue&type=script&lang=js&"
export * from "./RelocateSubSampleModal.vue?vue&type=script&lang=js&"
import style0 from "./RelocateSubSampleModal.vue?vue&type=style&index=0&id=640a3f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a3f94",
  null
  
)

export default component.exports